import countryList from 'country-list';

export type OnlyPromoteCountryOption = {
    code: string;
    name: string;
};

/** ISO 3166-1 alpha-2 codes with display names, sorted A–Z. */
export const ONLY_PROMOTE_COUNTRY_OPTIONS: OnlyPromoteCountryOption[] = countryList
    .getData()
    .map(({ code, name }) => ({ code: code.toUpperCase(), name }))
    .sort((a, b) => a.name.localeCompare(b.name));

const codes = new Set(ONLY_PROMOTE_COUNTRY_OPTIONS.map((c) => c.code));

/** Normalize stored/public-profile location to a valid country code, or null. */
export const normalizeOnlyPromoteCountryCode = (raw?: string | null): string | null => {
    if (!raw?.trim()) {
        return null;
    }

    const trimmed = raw.trim();
    const upper = trimmed.toUpperCase();
    if (upper.length === 2 && codes.has(upper)) {
        return upper;
    }

    const fromName = countryList.getCode(trimmed);
    if (fromName && codes.has(fromName.toUpperCase())) {
        return fromName.toUpperCase();
    }

    const lastSegment = trimmed.split(',').pop()?.trim();
    if (lastSegment) {
        const fromSegment = countryList.getCode(lastSegment);
        if (fromSegment && codes.has(fromSegment.toUpperCase())) {
            return fromSegment.toUpperCase();
        }
    }

    return null;
};

export const onlyPromoteCountryName = (code?: string | null): string => {
    if (!code?.trim()) {
        return '';
    }
    return countryList.getName(code.trim().toUpperCase()) || code;
};
